export const onboardingScreens = [
	{
		title: '¿Qué es Bumbei?',
		emoji: '👉',
		body: 'Compra en línea como siempre, pero esta vez… ¡Ganas bitcoin por hacerlo!',
		subtext:
			'Bumbei te devuelve una parte de tu compra en bitcoin. Fácil, rápido y sin complicaciones.',
	},
	{
		title: '¿Cómo funciona?',
		emoji: '🛒',
		body: '1. Elige una tienda desde Bumbei\n2. Compra normalmente\n3. Gana bitcoin en tu cuenta',
		subtext:
			'No necesitas códigos ni nada especial. Solo haz clic desde Bumbei y listo.',
	},
	{
		title: 'Tu wallet Lightning',
		emoji: '⚡',
		body: 'Para retirar tu bitcoin, necesitas una wallet compatible con Lightning.\nTe recomendamos: Muun o Blink Wallet.',
		subtext: 'Son seguras, gratuitas y fáciles de usar.',
	},
	{
		title: '¿Y cuándo me pagan?',
		emoji: '⏳',
		body: "Tu cashback aparece como 'pendiente' mientras la tienda confirma tu compra.\nEste proceso puede tardar entre 30 y 60 días.",
		subtext:
			'Una vez aprobado, tu saldo estará disponible para retirar en bitcoin.',
	},
	{
		title: '¡Listo para empezar!',
		emoji: '🎉',
		body: 'Explora tus tiendas favoritas y haz tu primera compra.',
		subtext:
			'Recuerda: el cashback solo se activa si compras después de hacer clic desde Bumbei.',
		cta: 'Explora tiendas',
	},
];
